import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import BackToTop from '../../components/BackToTop.jsx';
import ProductSlider from '../../components/modules/products/ProductSlider.jsx';
import HomeBuilder from '../../components/home/HomeBuilder.jsx';
import Carousel from '../../components/Carousel.jsx';

const backToTop = document.getElementById('back-to-top-container');
if (backToTop !== null) {
    ReactDOM.render(<BackToTop />, backToTop);
}

const categorySlider = document.getElementById('category-slider');
if (categorySlider !== null) {
    ReactDOM.render(<ProductSlider />, categorySlider);
}

const homeContent = document.getElementById('homecontent');
if (homeContent !== null) {
    ReactDOM.render(<HomeBuilder {...homeContent.dataset} />, homeContent);
}
